import BaseModel from '../core/BaseModel'
export default class ProvinceModel extends BaseModel {
    constructor() {
        super({ 
                name: "provinces",
                tableName: 'core_province'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            }
        },)
    }

}